<template><svg v-bind="$attrs"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 10">
  <path fill="#33819A" fill-rule="evenodd" d="M4.362 7.041 1.705 4.403a1 1 0 1 0-1.41 1.419L3.707 9.21a1 1 0 0 0 1.456-.05l6.588-7.5A1 1 0 0 0 10.25.34L4.362 7.041z" clip-rule="evenodd"/>
</svg>
</template>